<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps<{
  modelValue: string[]
  options: { value: string; label: string }[]
  disabled?: boolean
}>()
const emit = defineEmits<{ 'update:modelValue': [string[]] }>()

function toggle(value: string, checked: boolean, current: string[]): void {
  emit('update:modelValue', checked ? [...current, value] : current.filter((v) => v !== value))
}

function selectAll(options: { value: string }[]): void {
  emit(
    'update:modelValue',
    options.map((o) => o.value),
  )
}

function selectNone(): void {
  emit('update:modelValue', [])
}
</script>

<template>
  <div class="permission-group">
    <div class="actions">
      <button type="button" class="link-button" :disabled="disabled" @click="selectAll(options)">
        {{ t('common.selectAll') }}
      </button>
      <button type="button" class="link-button" :disabled="disabled" @click="selectNone">
        {{ t('common.selectNone') }}
      </button>
    </div>
    <label v-for="option in options" :key="option.value" class="checkbox-label">
      <input
        type="checkbox"
        :checked="modelValue.includes(option.value)"
        :disabled="disabled"
        @change="toggle(option.value, ($event.target as HTMLInputElement).checked, modelValue)"
      />
      {{ option.label }}
    </label>
  </div>
</template>

<style scoped>
.permission-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.actions {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.link-button {
  padding: 0;
  border: none;
  background: none;
  color: var(--tg-link-color);
  cursor: pointer;
  font-size: 0.85rem;
}

.link-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.15rem;
}

.checkbox-label input {
  width: auto;
}
</style>
